/**
 * AvatarPicker Styles
 * Styles for the AvatarPicker component
 * 3-column grid with even spacing
 */

import { StyleSheet } from 'react-native';

export const avatarPickerStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignContent: 'flex-start',
  },
});

